<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"RECRUITER.CONFLICTS" | translate}} </h5>
        <div class="edit-icons">
            <i class="material-icons" (click)="onClose()">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column">
        <div class="content-block flex-grow-1">
            <div class="flex-grow-1 d-flex flex-column ">
                <div  class="d-flex flex-column gap-3 overflow-scroll">
                
                    <div class="card-con" *ngFor="let item of conflictArr">
                        <div class="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                            <div class="d-flex gap-2 ">
                                <div class="profile-p">
                                    <img *ngIf="!item.profile_picture" src="assets/images/icons/employee.png" alt="">
                                    <img *ngIf="item.profile_picture" [src]="item.profile_picture" alt="">
                                </div>
                                <div class="d-flex sub-title align-items-center">{{item.first_name}} {{item.last_name}}</div>
                            </div>
                            <div class="title">{{item.date}}</div>
                        </div>


                        <div class="d-flex mt-3 mb-3 gap-3 flex-column " >
                            <div class="d-flex gap-3 align-items-end" *ngFor="let user of item.j_d">
                                <div class="flex-column">
                                    <div class="sub-title">{{user.j_c}}</div>
                                    <div class="time-div">
                                        {{user.st_ti}} - {{user.ed_ti}}
                                    </div>
                                </div>
                                <button mat-raised-button color="primary" (click)="onDeleteConflict(item.em_i,user.wo_ti_id,item.id)" class="new-btn">
                                    Delete
                                </button>
                            </div>
                        </div>
                        

                    </div>

                    <div class="content-c" *ngIf="conflictArr.length == 0">
                        <div class="thmub-ic mb-3">
                            <img src="assets/images/icons/thumb_ic.png" class="img-fluid" alt="">
                        </div>
                        <div class="m-title "> No conflicts to display </div>
                        <div class="m-sub-title"> Everything seems to be running smoothly </div>
                        <!-- <button mat-raised-button color="primary" class="auth-form-btn mt-3 mb-3">Set scheduler
                            limitations</button> -->
                    </div>
                </div>
              
            </div>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>